const Dotted = (props?: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      d="M12.0083 5.00041V5.01112M15.7579 6.00472L15.7525 6.01543M18.5042 8.74997L18.4935 8.75533M19.5085 12.4995H19.4978M18.5042 16.2491L18.4946 16.2437M15.759 18.9954L15.7536 18.9847M12.0083 19.9901V20.0008M8.26306 18.9868L8.25771 18.9965M5.52209 16.2448L5.51353 16.2502M4.51886 12.5006H4.50815M5.52209 8.75533L5.51353 8.74997M8.26306 6.01436L8.25771 6.00579"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
    />
  </svg>
);

export default Dotted;
